module.exports = __webpack_public_path__ + "public/SiteIcons/mailblack.svg?577b7cb3";